import styled from "styled-components";

export const Container = styled.div`
	max-width: 1142px;
	width: 90%;
	margin: 20px auto;
`;
